export function deriveVoiceFirstResponder(formData = {}) {
  const stored = String(formData._voice_first_responder || "").trim();
  if (["chatbot", "agent", "human", "none"].includes(stored)) return stored;
  const hasChatbot = formData.id_chatbot != null && String(formData.id_chatbot).trim() !== "";
  const hasAgent = formData.id_agente != null && String(formData.id_agente).trim() !== "";
  const hasHuman =
    Array.isArray(formData.idusuarios) && formData.idusuarios.some((id) => Number(id) > 0);
  if (hasChatbot) return "chatbot";
  if (hasAgent) return "agent";
  if (hasHuman) return "human";
  return "none";
}

export function validateTwilioPhoneRoutingQueue(formData, { t }) {
  const first = deriveVoiceFirstResponder(formData);
  const hasHumans =
    Array.isArray(formData.idusuarios) && formData.idusuarios.some((id) => Number(id) > 0);
  const hasChatbot = formData.id_chatbot != null && String(formData.id_chatbot).trim() !== "";
  const hasAgent = formData.id_agente != null && String(formData.id_agente).trim() !== "";
  const queueUsers = Array.isArray(formData.voice_queue_user_ids)
    ? formData.voice_queue_user_ids
    : [];
  const queueCargos = Array.isArray(formData.voice_queue_cargo_ids)
    ? formData.voice_queue_cargo_ids
    : [];
  const hasPool =
    queueUsers.some((id) => Number(id) > 0) || queueCargos.some((id) => Number(id) > 0);

  if (first === "chatbot" && !hasChatbot) {
    return t(
      "channelForm.twilioPhone.errPickChatbot",
      "Escolha o chatbot que vai atender a ligação."
    );
  }
  if (first === "agent" && !hasAgent) {
    return t(
      "channelForm.twilioPhone.errPickAgent",
      "Escolha o agente de IA que vai atender a ligação."
    );
  }
  if (first === "human" && !hasHumans) {
    return t(
      "channelForm.twilioPhone.errPickHuman",
      "Escolha o atendente que vai receber a ligação."
    );
  }
  if ((first === "chatbot" || first === "agent" || first === "none") && !hasPool) {
    return t(
      "channelForm.twilioPhone.errQueueRequired",
      "Escolha quem da equipe pode atender. Sem isso a ligação não tem humano."
    );
  }
  if (!hasChatbot && !hasAgent && !hasHumans && !hasPool) {
    return t(
      "channelForm.twilioPhone.errNoDestination",
      "Escolha quem fala primeiro ou quem da equipe atende."
    );
  }
  const wait = Number(formData.voice_queue_max_wait_sec);
  if (
    (hasPool || first === "human") &&
    (!Number.isFinite(wait) || wait < 30 || wait > 3600)
  ) {
    return t(
      "channelForm.twilioPhone.errMaxWait",
      "O tempo de espera deve ficar entre 30 segundos e 1 hora."
    );
  }
  return null;
}
